import localStore from 'local-storage';

export const TOGGLE_PEEK_DOWN = 'TOGGLE_PEEK_DOWN';
export const DISMISS_PEEK_DOWN = 'DISMISS_PEEK_DOWN';
export const SHOW_IF_AVAILABLE = 'SHOW_IF_AVAILABLE';

const initialState = {
  open: false,
  dismissed: false,
  show: false
};

const STORAGE_KEY = 'sk-dismiss-peek-down-onboard';

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_IF_AVAILABLE: {
      const isDismissed = localStore.get(STORAGE_KEY) !== null;

      return {
        ...state,
        show: !isDismissed,
        dismissed: isDismissed
      };
    }

    case TOGGLE_PEEK_DOWN: {
      const { open } = state;

      return {
        ...state,
        open: !open
      };
    }

    case DISMISS_PEEK_DOWN: {
      localStore.set(STORAGE_KEY, true);

      return {
        ...state,
        open: false,
        dismissed: true,
        show: false
      };
    }

    default:
      return state;
  }
}

export const toggle = () => ({
  type: TOGGLE_PEEK_DOWN
});

export const showIfAvailable = () => dispatch => {
  setTimeout(() => dispatch({
    type: SHOW_IF_AVAILABLE
  }), 1);
};

export const dismiss = () => ({
  type: DISMISS_PEEK_DOWN
});



/** WEBPACK FOOTER **
 ** ./app/store/peekDown/peekDown.js
 **/